import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './Breadcrumb.css';

class Breadcrumb extends Component {
  render() {
    const { url, title } = this.props;
    return (
      <div className="c-breadcrumb">
        <Link to={url} className="back-link">{title}</Link>
      </div>
    );
  }
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/common/breadcrumb/Breadcrumb.jsx